module.exports = __webpack_public_path__ + "static/hackthehood-7c086a84af8e72fa71a26f87352bc1f2.png";